import script from "./Confirmation.vue?vue&type=script&setup=true&lang=ts"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=ts"

import "./Confirmation.vue?vue&type=style&index=0&id=0e23d1b2&lang=scss"

const __exports__ = script;

export default __exports__